import React from 'react';
import useViewport from 'hooks/useViewport';

const CSS = require('./PushDown.less');
const SCREEN_LIMIT = 992;

function PushDown({ subNavbar }) {
  const { width } = useViewport();
  const noLocalFilterSubBar = width > SCREEN_LIMIT && subNavbar === 'localFilters';
  const classes = !subNavbar || noLocalFilterSubBar ? CSS.PushDownHalf : CSS.PushDown;

  if (!classes) {
    return null;
  }

  return (
    <div className={classes} />
  );
}

export default PushDown;
